import React, { FC } from 'react'
import { Controller, FieldError } from 'react-hook-form'
import styled from 'styled-components'

import { Text, ITextInput as ITextInputDS } from '@wirtualna-polska/n2cr-ds'
import { handleError } from '@ads/front-core/utils/form'
import { UseAdsFormReturn } from '@ads/front-core/hooks/useAdsForm'
import FormGroup, { IFormGroup } from '../FormGroup'
import Input from './Input'

export interface ITextInput
  extends Partial<Pick<UseAdsFormReturn<any>, 'control' | 'trigger'>>,
    Omit<IFormGroup, 'error'> {
  name: string
  defaultValue?: unknown
  caption?: string
  value?: string
  type?: ITextInputDS['type'] | 'currency'
  placeholder?: string
  disabled?: boolean
  prefix?: string
  sufix?: string
  error?: FieldError
  step?: number
  readOnly?: boolean
  tooltip?: string
  labelAfterInput?: string
  withClipboardCopy?: boolean
}

interface ITextInputArchived extends Omit<IFormGroup, 'error'> {
  value: any
}

const TextInput: FC<ITextInput> = ({
  name,
  control,
  type,
  defaultValue,
  placeholder,
  disabled,
  prefix,
  sufix,
  error,
  step = 0.01,
  readOnly,
  tooltip,
  labelAfterInput,
  withClipboardCopy,
  trigger,
  ...rest
}) => (
  <FormGroup error={error} disabled={disabled} {...rest}>
    {control ? (
      <Controller
        render={({ field, fieldState }) => (
          <Input
            field={field}
            fieldState={fieldState}
            type={type}
            placeholder={placeholder}
            disabled={disabled}
            prefix={prefix}
            sufix={sufix}
            hasError={!!handleError(error)}
            step={step}
            readOnly={readOnly}
            tooltip={tooltip}
            trigger={trigger}
            labelAfterInput={labelAfterInput}
            withClipboardCopy={withClipboardCopy}
          />
        )}
        name={name}
        control={control}
        defaultValue={defaultValue}
      />
    ) : (
      <Input
        type={type}
        defaultValue={defaultValue}
        placeholder={placeholder}
        disabled={disabled}
        prefix={prefix}
        sufix={sufix}
        hasError={!!handleError(error)}
        step={step}
        readOnly={readOnly}
        tooltip={tooltip}
        trigger={trigger}
        labelAfterInput={labelAfterInput}
      />
    )}
  </FormGroup>
)

export const TextInputArchived: FC<ITextInputArchived> = ({
  value,
  disabled,
  ...rest
}) => (
  <FormGroup disabled={disabled} {...rest}>
    <TextInputArchivedValue>{value}</TextInputArchivedValue>
  </FormGroup>
)

const TextInputArchivedValue = styled(Text)`
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  display: inline-block;
  white-space: pre-line;
`

export default TextInput
